export function buildAssetUrl(asset, preferred = 'authenticated') {
  if (!asset) return '';
  if (typeof asset === 'string') return asset;
  if (typeof asset !== 'object') return '';
  const id = Number(asset.id) || 0;
  if (preferred === 'public' && asset.publicTokenHash && id > 0) {
    return `/api/media-assets/${id}/public`;
  }
  if (typeof asset.url === 'string' && asset.url.startsWith('http')) return asset.url;
  if (typeof asset.publicUrl === 'string' && asset.publicUrl.startsWith('http')) return asset.publicUrl;
  if (typeof asset.storageUrl === 'string' && asset.storageUrl.startsWith('http')) return asset.storageUrl;
  if (id > 0) return `/api/media-assets/${id}`;
  return '';
}

export function truncateText(text, max = 120) {
  const t = String(text || '').trim();
  if (!t) return '';
  if (t.length <= max) return t;
  return `${t.slice(0, max - 1)}…`;
}

export function formatDateTime(value) {
  if (!value) return '-';
  try {
    return new Date(value).toLocaleString();
  } catch (_) {
    return String(value);
  }
}

export function safeCopy(text) {
  if (!text) return false;
  try {
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(String(text)).catch(() => {});
      return true;
    }
  } catch (_) { /* noop */ }
  try {
    const ta = document.createElement('textarea');
    ta.value = String(text);
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (_) { /* noop */ }
    document.body.removeChild(ta);
    return true;
  } catch (_) {
    return false;
  }
}
